module.exports = __webpack_public_path__ + "product-compound-capsule-09.jpg?23d5432da15e3ea8e681c2eabcf100fb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-compound-capsule-09.jpg
// module id = 106
// module chunks = 0